<slotcom-limited-time-events-layout
  [event]="event"
  [modalName]="NonPersistedModalName.SlotcardModalComponent"
  [infoModal]="NonPersistedModalName.SlotcardInfoModalComponent">
  <ng-container left-container>
    <div class="w-100 h-100 d-flex justify-content-center align-items-center position-relative">
      <div
        class="c-slotcard__icon"
        theming
        themingGroup="slotcard"
        themingAsset="logo"
        [themingOverride]="event?.assets"></div>
      @if (event.properties.extrarewardpercentage != 0) {
        <div class="c-slotcard__discount">
          <slotcom-box [classes]="['percent']">
            <span class="text percent">{{ event.properties.extrarewardpercentage }}&#37;</span>
            <span class="text extra">{{ 'home.live-ops.slotcard.extra' | translate }}</span>
          </slotcom-box>
        </div>
      }
    </div>
    <span class="c-slotcard__copy text">{{ 'home.live-ops.slotcard.text' | translate }}</span>
    <div class="w-100 h-100 d-flex justify-content-center align-items-center flex-column">
      @if (!event.infiniteTimes && event.maxCompletionTimes === 1) {
        <span class="text times">{{ 'home.live-ops.global.times-valid' | translate }}</span>
      }
      @if (!event.infiniteTimes && event.maxCompletionTimes > 1) {
        <span class="text times">{{
          'home.live-ops.global.times-valid-2' | translate: { times: event.maxCompletionTimes }
        }}</span>
      }
      @if (event.infiniteTimes) {
        <span class="text times">{{ 'home.live-ops.global.times-valid-3' | translate }}</span>
      }

      @if ((slotcardMinPurchase | number) != 0) {
        <slotcom-box [classes]="['minPurchase']">
          <span class="text"
            >{{ 'home.live-ops.slotcard.min-purchase' | translate }} {{ slotcardMinPurchase }}
            {{ slotcardCurrencySymbol }}</span
          >
        </slotcom-box>
      }
    </div>
    <div
      class="c-slotcard__timer"
      [ngClass]="(slotcardMinPurchase | number) != 0 ? '' : 'c-slotcard__timer--margin'">
      <span class="text">{{ 'home.live-ops.global.time-left' | translate }}</span>
      <slotcom-animated-timer
        [showInDays]="true"
        [endDate]="event.endDate"
        (expired)="closeModal()"></slotcom-animated-timer>
    </div>
  </ng-container>

  <ng-container right-container>
    <div class="d-flex justify-content-center flex-column align-items-center mt-2">
      <div class="c-slotcard__progressive">
        <div class="e-stamper"></div>
        <span class="text">{{ 'home.live-ops.slotcard.title' | translate }}</span>
        <slotcom-stamp-progress
          [rescaleWithEm]="0.9"
          [event]="event"></slotcom-stamp-progress>

        @if (event.properties.purchases.length) {
          <slotcom-display [classes]="['c-display--slotcard']">
            <div
              displayIcon
              displayIconPos="left"
              class="c-display--coin"></div>
            <span>{{ slotcardAveragePurchases | number: '1.0-0' : ('common.culture' | translate) }}</span>
          </slotcom-display>
          <div class="l-footer">
            <div class="footer-text noExtra">
              <span class="text">{{ 'home.live-ops.slotcard.subtitle-1' | translate }}</span>
              <span class="text">{{ 'home.live-ops.slotcard.subtitle-2' | translate }}</span>
            </div>
            @if (event.properties.extrarewardpercentage != 0) {
              <span class="text plus">&#43;</span>
              <div class="footer-text extra">
                <span class="text"
                  >{{ event.properties.extrarewardpercentage }}&#37;
                  {{ 'home.live-ops.slotcard.extra' | translate }}</span
                >
                <span class="text">{{ 'home.live-ops.slotcard.subtitle-3' | translate }}</span>
              </div>
            }
          </div>
        } @else {
          @if (event.properties.freesteps == 0) {
            <div class="l-footer">
              <div class="footer-text noPurchases">
                <span class="text">{{ 'home.live-ops.slotcard.no-stamps-subtitle-1' | translate }}</span>
                <span class="text">{{ 'home.live-ops.slotcard.no-stamps-subtitle-2' | translate }}</span>
              </div>
            </div>
          }
          @if (event.properties.freesteps == 1) {
            <div class="l-footer">
              <div class="footer-text noPurchases">
                <span class="text">{{ 'home.live-ops.slotcard.free-stamp-subtitle-1' | translate }}</span>
                <span class="text">{{ 'home.live-ops.slotcard.free-stamp-subtitle-2' | translate }}</span>
              </div>
            </div>
          }
          @if (event.properties.freesteps > 1) {
            <div class="l-footer">
              <div class="footer-text noPurchases">
                <span class="text">{{ 'home.live-ops.slotcard.free-stamps-subtitle-1' | translate }}</span>
                <span class="text">{{ 'home.live-ops.slotcard.free-stamp-subtitle-2' | translate }}</span>
              </div>
            </div>
          }
        }

        <ng-template #noPurchases>
          @if (event.properties.freesteps == 0) {
            <div class="l-footer">
              <div class="footer-text noPurchases">
                <span class="text">{{ 'home.live-ops.slotcard.no-stamps-subtitle-1' | translate }}</span>
                <span class="text">{{ 'home.live-ops.slotcard.no-stamps-subtitle-2' | translate }}</span>
              </div>
            </div>
          }

          @if (event.properties.freesteps == 1) {
            <div class="l-footer">
              <div class="footer-text noPurchases">
                <span class="text">{{ 'home.live-ops.slotcard.free-stamp-subtitle-1' | translate }}</span>
                <span class="text">{{ 'home.live-ops.slotcard.free-stamp-subtitle-2' | translate }}</span>
              </div>
            </div>
          }

          @if (event.properties.freesteps > 1) {
            <div class="l-footer">
              <div class="footer-text noPurchases">
                <span class="text">{{ 'home.live-ops.slotcard.free-stamps-subtitle-1' | translate }}</span>
                <span class="text">{{ 'home.live-ops.slotcard.free-stamp-subtitle-2' | translate }}</span>
              </div>
            </div>
          }
        </ng-template>
      </div>

      <slotcom-button
        class="c-button--pink"
        data-testid="slotcard-open-shop-button"
        (safeClick)="openShop()"
        audioType="functionality">
        {{
          event.statusCultureButtonText[lang]
            ? event.statusCultureButtonText[lang]
            : ('home.buttons.for-stamps' | translate | uppercase)
        }}
      </slotcom-button>
    </div>
  </ng-container>
</slotcom-limited-time-events-layout>
